<template>
    <div class="rechargeBox">
        <div style="display: flex">
            <el-form ref="listArgument" :model="listArgument">
                <el-form-item>
                    <el-date-picker v-model="value" type="daterange" value-format="yyyy-MM-dd" @change="chosedatetime"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="searchBox">
                <el-button type="primary" @click="searchBtn">搜索</el-button>
                <el-button @click="clearBtn">清空</el-button>
            </div>
        </div>
        <!-- <h3 style="color:#409EFF">合计：{{heji}}元</h3> -->
        <avue-crud :data="data" :option="option" :page.sync='page' @current-change='changePage'
            @size-change="sizeChange">
            <template slot-scope="scope" slot="money">
                <span>
                    <span v-if="scope.row.add_or_sub == 1" style="color: #11b006">+{{ scope.row.money }}</span>
                    <span v-if="scope.row.add_or_sub == 2" style="color: #FF0000">-{{ scope.row.money }}</span>
                </span>
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { rechargeRecordList } from '@/api/personal';

export default {
    name: "rechargeRecord",
    data() {
        return {
            listArgument: {
                begin_time: '',
                end_time: '',
                limit: 10,
                page: 1
            },
            page: {
                currentPage: 1,
                total: 20,  //总数
                pageSize: 10  //每页条数
            },
            value: [],
            heji: '',
            data: [],
            option: {
                stripe: true,
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuType: 'menu',
                menu: false,
                menuBtnTitle: '操作',
                column: [
                    // {
                    //     label: '账单ID',
                    //     prop: 'id'
                    // },
                    {
                        label: '时间',
                        prop: 'create_time'
                    },
                    {
                        label: '计费类型',
                        prop: 'fangshi_txt'
                    },
                    {
                        label: '余额或次数',
                        prop: 'money'
                    },
                    {
                        label: '备注',
                        prop: 'remark',
                        width: 400
                    },
                ]
            }
        }
    },
    methods: {
        chosedatetime(obj) {
            if (obj) {
                this.listArgument.begin_time = obj[0]
                this.listArgument.end_time = obj[1]
            } else {
                this.listArgument.begin_time = ''
                this.listArgument.end_time = ''
            }
        },
        // 分页
        changePage(num) {
            this.listArgument.page = num;
            rechargeRecordList(this.listArgument).then(res => {
                this.data = res.data.list;
                this.page.total = res.data.count;
            })
        },
        // 切换每一页条数
        sizeChange(val) {
            this.listArgument.limit = val;
            this.listArgument.page = 1;
            this.getList();
        },
        // 搜索
        searchBtn() {
            this.getList();
        },
        // 清空
        clearBtn() {
            this.value = [];
            this.listArgument.begin_time = ''
            this.listArgument.end_time = ''
            this.listArgument.page = 1;
            this.getList();
        },
        getList() {
            rechargeRecordList(this.listArgument).then(res => {
                if (res.code == 200) {
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = 1
                    this.heji = res.data.heji
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped>
.rechargeBox {
    background-color: #ffffff;
    padding: 20px;
    margin: 10px;
    border-radius: 5px;
}

.searchBox {
    margin-left: 20px;
}

::v-deep .avue-crud__menu {
    min-height: 0px;
}
</style>